<template>
    <div id="containerProductCard">
        <svg :style="{'width': svg.width + 'px', 'height': svg.height + 'px' }">
            <transition-group name="list" appear tag="g">
                <g v-for="(node, nodeIdx) in nodes" :key="node.data.month + node.data.productCode">
                    <title>
                        {{ node.data.productCode }}
                    </title>
                    <rect
                        style="cursor:pointer"
                        :x="node.x0"
                        :y="svg.paddingT + node.y0"
                        rx="5"
                        ry="5"
                        :width="node.x1 - node.x0"
                        :height="node.y1 - node.y0"
                        :fill="nodeIdx < 1 ? themeColors.warning : themeColors.primary"
                        @click="emitDetailLayer(node.data.productCode)"
                    >
                    </rect>
                    <text
                        v-if="(node.y1 - node.y0) > 20"
                        style="cursor:pointer"
                        :x="node.x0 + 4"
                        :y="svg.paddingT + node.y0 + 5"
                        fill="#fff"
                        text-anchor="start"
                        @click="emitDetailLayer(node.data.productCode)"
                    >
                        <tspan
                            alignment-baseline="hanging"
                            :style="{'font-weight': nodeIdx < 1 ? 'bold' : 'normal'}">
                            {{ node.data.productCode ? node.data.productCode.replace('Amazon', '').replace('AWS','') : '' }}
                        </tspan>
                        <tspan
                            v-if="totalCost>0"
                            alignment-baseline="hanging"
                            font-size="12"
                            dy="2"
                        >
                            {{ Math.round(node.value / totalCost * 1000) / 10 }}%
                        </tspan>
                    </text>
                    <text
                        v-if="(node.y1 - node.y0) > 40"
                        style="cursor:pointer"
                        :x="node.x0 + 4"
                        :y="svg.paddingT + node.y0 + 33"
                        fill="#fff"
                        text-anchor="start"
                        font-size="12"
                        @click="emitDetailLayer(node.data.productCode)"
                    >
                        ${{ __toKFormat(node.value) }}
                    </text>
                </g>
            </transition-group>
        </svg>
        <b-alert
            class="p-1 mb-0"
            :variant="theme"
            show
        >
            <p class="float-right" v-if="bottomCards.length > 1">
                <a @click="showNextCard">
                    <i class="fas fa-chevron-circle-right"></i>
                </a>
            </p>
            <template v-if="bottomCardItem">
                <h6 class="text-nowrap" v-html="bottomCardItem.title"></h6>
                <p class="mt-1 mb-0 text-nowrap" style="line-height:14px;">
                    <small class="font-weight-bold font-italic">
                        {{ bottomCardItem.message }}
                    </small>
                </p>
            </template>
        </b-alert>
    </div>
</template>

<script>
import useCommonData from '@/composables/useCommonData'
import { computed, inject, getCurrentInstance, ref, onMounted, onUnmounted, toRefs, watch } from '@vue/composition-api'
export default {
    props: {
        mode: {
            type: String,
            default: null
        },
        svg: {
            type: Object,
            default: function () {
                return {}
            }
        },
        data: {
            type: Object,
            default: function () {
                return {
                    thisMonthProducts: [],
                    lastMonthProducts: []
                }
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { data, svg } = toRefs(props)
        const themeColors = inject('themeColors')
        const theme = inject('theme')
        const { __toKFormat } = useCommonData()
        const d3 = vm.$d3
        const cardToShow = ref(0)
        const timeoutId = ref(null)
        const thisMonthProducts = computed(() => props.data.thisMonthProducts || [])
        const lastMonthProducts = computed(() => props.data.lastMonthProducts || [])
        const maxCost = computed(() => Math.max.apply(null, thisMonthProducts.value.map(item => item.cost)))
        const totalCost = computed(() => thisMonthProducts.value.map(item => item.cost).reduce((a, b) => a + b, 0))
        // const productCostRising = computed(() => {
        //     return thisMonthProducts.value.map(tm => {
        //         const findItem = lastMonthProducts.value.find(lm => lm.productCode === tm.productCode)
        //         return {
        //             productCode: tm.productCode,
        //             costIncrease: tm.cost - ((findItem && findItem.cost) || 0)
        //         }
        //     }).sort((a, b) => a.costIncrease > b.costIncrease ? -1 : 1)
        //         .filter((item, itemIdx) => item.costIncrease > 0 && itemIdx < 1)
        //         .map(item => {
        //             return {
        //                 title: item.productCode + ' <small>' + (vm.$_getDollar(item.costIncrease) ? vm.$_getDollar(item.costIncrease).replace(' ', '') : '') + ' <i class="fas fa-caret-up"></i></small>',
        //                 message: 'highest cost increasing'
        //             }
        //         })
        // })
        const productCostRising = computed(() => {
            const lastMonthProductsMap = new Map()
            lastMonthProducts.value.forEach(product => {
                lastMonthProductsMap.set(product.productCode, product.cost)
            })

            const thisMonthProductsCostIncreases = thisMonthProducts.value.map(tm => {
                const lastMonthCost = lastMonthProductsMap.get(tm.productCode) || 0
                return { productCode: tm.productCode, costIncrease: tm.cost - lastMonthCost }
            })

            const sortedIncreases = thisMonthProductsCostIncreases
                .filter(item => item.costIncrease > 0)
                .sort((a, b) => b.costIncrease - a.costIncrease)

            const highestIncrease = sortedIncreases[0]

            if (highestIncrease) {
                return [{
                    title: highestIncrease.productCode + ' <small>' + (vm.$_getDollar(highestIncrease.costIncrease) || '') + ' <i class="fas fa-caret-up"></i></small>',
                    message: vm.$t('v4.highest cost increasing')
                }]
            } else {
                return []
            }
        })
        const newProductsThisMonth = computed(() => {
            const tmp = thisMonthProducts.value.filter(tm => {
                return !lastMonthProducts.value.filter(lm => lm.productCode === tm.productCode).length
            }).map(item => item.productCode)

            return tmp.length ? {
                title: tmp.length < 3 ? tmp.join(', ') : tmp[0] + ' <small> & ' + (tmp.length - 1) + ` ${'v4.more products'}</small>`,
                message: vm.$t('v4.new products of the month')
            } : null
        })
        // const bottomCards = computed(() => [productCostRising.value, productPercentageRising.value, newProductsThisMonth.value].filter(item => item !== null).reduce((acc, val) => acc.concat(val), []))
        const bottomCards = computed(() => [productCostRising.value, newProductsThisMonth.value].filter(item => item !== null).reduce((acc, val) => acc.concat(val), []))
        const bottomCardItem = computed(() => bottomCards.value[cardToShow.value])
        const currentDataSummarized = computed(() => {
            return thisMonthProducts.value.map((item, itemIdx) => {
                return itemIdx < 7 ? item : {
                    productCode: 'Etc',
                    cost: item.cost
                }
            }).reduce((acc, val) => {
                if (acc.filter(item => item.productCode === val.productCode).length) {
                    acc.filter(item => item.productCode === val.productCode)[0].cost += val.cost
                } else {
                    acc.push(val)
                }
                return acc
            }, [])
        })
        const root = computed(() => {
            const hier = d3.hierarchy({
                name: 'root',
                cost: 0,
                children: currentDataSummarized.value.filter(item => item.cost >= 0)
            }).sum((d) => +d.cost)
            d3
                .treemap()
                .tile(d3.treemapBinary)
                .size([svg.value.width, svg.value.height - svg.value.paddingT])
                .padding(2)(hier)
            return hier
        })
        const nodes = computed(() => root.value.leaves())
        const emitHandleResize = () => context.emit('resize:svg')
        const emitDetailLayer = productCode => context.emit('detail-layer', productCode)
        const showNextCard = () => {
            clearTimeout(timeoutId.value)
            cardToShow.value = (cardToShow.value + 1) % bottomCards.value.length
            timeoutId.value = setTimeout(showNextCard, 5000)
        }
        timeoutId.value = setTimeout(showNextCard, 5000)
        onMounted(() => {
            window.addEventListener('resize', emitHandleResize)
            vm.$nextTick(() => {
                emitHandleResize()
            })
        })
        onUnmounted(() => {
            clearTimeout(timeoutId)
            window.removeEventListener('resize', emitHandleResize)
        })
        watch(data, (value) => {
            cardToShow.value = 0
        })
        return {
            themeColors,
            theme,
            __toKFormat,
            totalCost,
            timeoutId,
            maxCost,
            bottomCards,
            bottomCardItem,
            nodes,
            emitDetailLayer,
            showNextCard
        }
    }
}
</script>

<style>

</style>
